import React, { useState, useEffect, useRef } from 'react';
import { FiAward, FiMap, FiUsers } from 'react-icons/fi';

const StatisticsSection = () => {
  const stats = [
    { label: "Customers", value: 1600000, suffix: "M+", displayVal: "1.6M+", icon: <FiUsers /> },
    { label: "Sq. Kilometers", value: 57000, suffix: "K+", displayVal: "57K+", icon: <FiMap /> },
    { label: "Office Locations", value: 350, suffix: "", displayVal: "350", icon: <FiAward /> },
  ];

  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasStarted]);

  return (
    <section ref={sectionRef} className="relative z-20 py-6 sm:py-10">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-wrap justify-center items-center gap-6 lg:gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="group rounded-2xl bg-white p-5 sm:p-8 text-center shadow-lg ring-1 ring-green-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:ring-green-600 w-full sm:w-[calc(50%-12px)] lg:w-[calc(25%-24px)] max-w-xs"
            >
              <div className="mx-auto mb-4 sm:mb-5 flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-2xl bg-green-100 text-2xl sm:text-3xl text-green-700 transition duration-300 group-hover:bg-green-700 group-hover:text-white">
                {stat.icon}
              </div>
              <h2 className="mb-1 sm:mb-2 text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900">
                <Counter target={stat.value} suffix={stat.suffix} active={hasStarted} />
              </h2>
              <p className="text-[10px] sm:text-sm font-semibold uppercase tracking-[0.15em] sm:tracking-[0.2em] text-gray-500">
                {stat.label}
              </p>
              <div className="mx-auto mt-3 sm:mt-5 h-1 w-8 sm:w-10 rounded-full bg-green-600 transition-all duration-300 group-hover:w-16 sm:group-hover:w-20"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Counter = ({ target, suffix, active }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) return;

    let start = 0;
    const duration = 2000; 
    const incrementTime = 30;
    const steps = duration / incrementTime;
    const increment = target / steps;

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [active, target]);

  const formatNumber = (num) => {
    if (target === 1600000) {
      return (num / 1000000).toFixed(1) + "M+";
    }
    if (target === 57000) {
      return Math.floor(num / 1000) + "K+";
    }
    return num.toLocaleString();
  };

  return <span>{formatNumber(count)}</span>;
};

export default StatisticsSection;